var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.IModal,[_c('p',{class:_vm.$style.title},[_c('i',{staticClass:"icon-envelope-o"}),_vm._v("再出品メールに登録しました")]),_vm._v(" "),_c('p',[_vm._v("メールが届かない場合、ご入力いただいたメールアドレスに誤りがある、またはiichi.comのドメイン許可設定がされていない場合がございます。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }